import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectBathrooms, selectBedrooms } from '../../../store/slices/dictionaries';

import CLSelect from '../../../components/CLSelect';
import CLInput from '../../../components/CLInput';
import CLDropdown from '../../../components/CLDropdown';
import CLFontIcon from '../../../components/CLFontIcon';

import {
  Container, FilterContainer, ResetButton, Field, Label,
} from './styled';

const Header = ({
  search, onSearch, filters, onFilter, isFiltersDefault, onReset,
}) => {
  const { t } = useTranslation();

  const bedrooms = useSelector(selectBedrooms);
  const bathroom = useSelector(selectBathrooms);

  const onChangeFilters = (value, fieldCode) => {
    onFilter({
      key: fieldCode,
      value,
    });
  };

  return (
    <Container>
      <CLInput
        icon="search-outline"
        placeholder={`${t('search_placeholder', 'Search our listings')}...`}
        value={search}
        onChange={onSearch}
      />
      <FilterContainer>
        <CLDropdown
          label={t('filter', 'Filter')}
          renderContent={() => (
            <>
              <Field>
                <Label>
                  <CLFontIcon icon="bed" />
                  {t('beds', 'Beds')}
                </Label>

                <CLSelect
                  options={bedrooms}
                  keyExtractor={(item) => item.bedroom_id}
                  value={filters.bedrooms || ''}
                  onChange={(value) => onChangeFilters(value, 'bedrooms')}
                />
              </Field>

              <Field>
                <Label>
                  <CLFontIcon icon="bathroom" />
                  {t('bath', 'Bath')}
                </Label>

                <CLSelect
                  options={bathroom}
                  keyExtractor={(item) => item.bathroom_id}
                  value={filters.bathrooms || ''}
                  onChange={(value) => onChangeFilters(value, 'bathrooms')}
                />
              </Field>

              <Field>
                <Label>
                  <CLFontIcon icon="size" />
                  {t('size', 'Size')}
                </Label>

                <div className="range">
                  <CLInput
                    placeholder={t('min', 'Min')}
                    value={filters.size_min}
                    onChange={(value) => onChangeFilters(value, 'size_min')}
                  />
                  <CLInput
                    placeholder={t('max', 'Max')}
                    value={filters.size_max}
                    onChange={(value) => onChangeFilters(value, 'size_max')}
                  />
                </div>

              </Field>

              <Field>
                <Label>
                  <CLFontIcon icon="params" />
                  {t('price', 'Price')}
                </Label>

                <div className="range">
                  <CLInput
                    placeholder={t('min', 'Min')}
                    value={filters.rent_min}
                    onChange={(value) => onChangeFilters(value, 'rent_min')}
                  />
                  <CLInput
                    placeholder={t('max', 'Max')}
                    value={filters.rent_max}
                    onChange={(value) => onChangeFilters(value, 'rent_max')}
                  />
                </div>

              </Field>
            </>
          )}
        />
        {!isFiltersDefault && <ResetButton primary onClick={onReset}>{t('reset', 'Reset')}</ResetButton>}
      </FilterContainer>
    </Container>
  );
};

Header.propTypes = {
  search: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
  isFiltersDefault: PropTypes.bool.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default Header;
